<input type="file" (change)="fileChange($event)" [accept]="fileType" #hiddenInput>
<eon-ui-button (click)="hiddenInput.click()" text="{{buttonText}}" icon="upload"></eon-ui-button>
<p>{{filename}}</p>
